var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0172303 12.9911L2.74854 16.0382L5.51625 13.0241L3.34368 13.0111L3.42167 0.0230393L2.26718 0.0161062L2.18918 13.0042L0.0172303 12.9911Z",
    fill: "#EFF3F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0804 3.11044L10.3491 0.0633866L7.58141 3.07742L9.75398 3.09047L9.67598 16.0785L10.8305 16.0855L10.9085 3.0974L13.0804 3.11044Z",
    fill: "#EFF3F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSort);
export default __webpack_public_path__ + "static/media/icon_sort.6751367e5c71a8e6405468b8e5bca4c6.svg";
export { ForwardRef as ReactComponent };